/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiSubscription, ApiSubscribe } from "../../wire/ApiSubscriber";
import type { AlmsyncCommonApiHandler } from "./Handler";
import { iterationSyncUpdatedEventSchema, runningStateUpdatedEventSchema } from "./schemas";

export const subscribeAlmsyncCommon: ApiSubscribe<AlmsyncCommonApiHandler> = (
  subscriber,
  variables,
  handler,
) => {
  const subscriptions = new Array<ApiSubscription>();
  if (handler.runningStateUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.almsync.v1.sessions.${sessionId}.running_state.updated",
          variables,
          types: { sessionId: String },
        },
        runningStateUpdatedEventSchema,
        handler.runningStateUpdated,
        [],
      ),
    );
  }
  if (handler.iterationSyncUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.almsync.v1.sessions.${sessionId}.iteration_sync.updated",
          variables,
          types: { sessionId: String },
        },
        iterationSyncUpdatedEventSchema,
        handler.iterationSyncUpdated,
        [],
      ),
    );
  }
  return subscriptions;
};
